const ORDER_FIELDS = ["orderid", "orderId", "orderNumber", "order"];

const present = (value) =>
	value !== undefined && value !== null && String(value).trim() !== "";

export const getOrganizerOrderLabel = (...sources) => {
	const candidates = ORDER_FIELDS.flatMap((field) =>
		sources.map((source) => source?.[field]),
	);
	const value = candidates.find(present);
	if (!present(value)) return null;

	const orderNumber = String(value).trim().replace(/^#/, "");
	return orderNumber ? `#${orderNumber}` : null;
};
